<template>
  <div>
    <user :child-msg="analyzerData"></user>
  </div>
</template>

<script>
import User from '@/components/User'

export default {
  data () {
    return {
      analyzerData: {
        type: 'analyzer',
        typeName: '分析人员',
        tableCols: [{
          type: 'userPhone',
          name: '手机号码'
        },{
          type: 'userId',
          name: '用户ID'
        }, {
          type: 'userName',
          name: '姓名'
        }]
      }
    }
  },

  components: {
    'user': User
  },
  mounted () {

  },

  methods: {}
}
</script>

<style lang="scss" scoped>

</style>
